import apiClient from "@/shared/api/apiClient";

export const getOrganizationList = async (params = {}) => {
  try {
    const { data } = await apiClient.get("/organizations/list", {
      params,
    });
    if (Array.isArray(data?.payload)) return data.payload;
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.items)) return data.items;
    return [];
  } catch (e) {
    console.error("[getOrganizationList]", e);
    return [];
  }
};
